import {
    reactive,
    watch
} from 'vue'

import {
    AValidate
} from '../utils'

const useAField = (props, ctx) => {

    let store = reactive({
        state: {
            field: true,
            focus: false,
            filled: false,
            error: props.error,
            'static-label': props.staticLabel,
            ...props.state
        },
        errorMsg: props.errorMsg && null
    })

    const focusIn = (e) => {
        store.state.focus = true
        ctx.emit(e.type, e)
    }

    const focusOut = (e) => {
        store.state.focus = false
        ctx.emit(e.type, e)
    }

    const validate = () => {
        let error = AValidate(props.validator, props.modelValue)
        store.state.error = error.status;
        store.errorMsg = error.msg;
        return error.status ? false : true
    }

    props.validator && watch(() => props.modelValue, () => validate())

    return {
        store,
        focusIn,
        focusOut,
        validate
    }
}

export {
    useAField
}